export default __webpack_public_path__ + "static/media/portmone.63bd7acd.svg";